import { useQuery } from 'react-query'
import { get } from '../api'
import { CountryData } from '../types/countries'

export const useCountryData = (countryName: string) => {
  return useQuery(['country_cases', countryName], async () => {
    const countries = await get<{ data: CountryData }>(
      `/countries/${countryName}`
    )
    return countries?.data?.data
  })
}
